import {
    addOpenApiClient,
    deleteOpenApiClient,
    getOpenApiClientList,
    resetOpenApiClient,
    updateOpenApiClientStatus
} from "@axios/api.account";
import { RootStoreModel } from "@redux/reducers";
import { gaEvent } from "@src/withTracker";
import {
    Badge,
    Breadcrumb,
    Button,
    Col,
    ConfigProvider,
    Empty,
    Form,
    FormInstance,
    Input,
    Modal,
    notification,
    Pagination,
    Row,
    Select,
    Space,
    Table
} from "antd";
import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { BasicStateForListModel } from "../models";

import i18n from "@src/locales";
import en_US from "antd/es/locale/en_US";
import zh_CN from "antd/es/locale/zh_CN";
import { Translation } from "react-i18next";

interface stateModel extends BasicStateForListModel {
    search: string,
    modalVisible:boolean,
    formType:string,
    selectId:string
}

interface propsModel extends RouteComponentProps<any, any, any> {}

const { Column } = Table;
const { Option } = Select;
const mapStatetoProps = (state: RootStoreModel) => ({})

class OpenApi extends React.Component<propsModel, stateModel> {
    formRef = React.createRef<FormInstance>();
    constructor(props: propsModel) {
        super(props);
        this.state = {
            loading: false,
            columns: [],
            data: [],
            pageIndex: 1,
            pageSize: 20,
            totalCount: 0,
            search:"",
            modalVisible:false,
            formType:"add",
            selectId:""
        }
        this.getList();
    }

    getList(pageIndex=this.state.pageIndex, pageSize=this.state.pageSize) {
        this.setState({loading: true});

        var paramsData = {
            Search:this.state.search,
            PageIndex: pageIndex,
            PageSize: pageSize
        };
        getOpenApiClientList(paramsData).then(
            res => {
                this.setState({
                    data: res.dataList,
                    pageIndex: res.pageIndex,
                    pageSize: res.pageSize,
                    totalCount: res.totalCount,
                });
            },
            () => {
                notification.error({message: <Translation>{t => {return t("查询失败")}}</Translation>});
            }
        ).finally(
            () => {
                this.setState({loading: false});
            }
        )
        
    }

    onSearch() {
        this.getList(1);
    }

    deleteClick =(id:any)=>{
        deleteOpenApiClient(id).then(res=>{
            this.getList();
        })
    }
    editClick =(row:any)=>{
        console.log("editClick",row,this.formRef)
        this.setState( prevState => ({
            modalVisible:true,
            formType:"edit",
            selectId:row.id
        }),()=>{ this.formRef.current?.setFieldsValue({...row});})
    }
    addClick = () => {
        this.setState({
            modalVisible:true,
            formType:"add"
        })
        
    }
    resetEncryptionKey=()=>{
        resetOpenApiClient(this.state.selectId).then((re:any)=>{
            this.getList();
            this.setState( prevState => ({
                formType:"show"
            }),()=>{this.formRef.current?.setFieldsValue(re);})
        })

    }
    copyEncryptionKey=()=>{
        this.formRef.current?.validateFields().then(
            (res) => {
                navigator.clipboard.writeText(res.encryptionKey).then(() => {
                    notification.success({ message: <Translation>{t => {return t("复制成功")}}</Translation> });
                }).catch(err => {
                    console.error('Could not copy text: ', err);
                });

            })

    }
    formOK=()=>{
        this.formRef.current?.validateFields().then(
            (res) => {
                if(this.state.formType =="add"){
                    addOpenApiClient(res).then((re:any)=>{
                        this.getList();
                        this.setState( prevState => ({
                            formType:"show"
                        }),()=>{this.formRef.current?.setFieldsValue(re);})
                    })
                }else if(this.state.formType =="edit"){
                    updateOpenApiClientStatus({id:this.state.selectId,status:res.status==0?"valid":"invalid",name:res.name}).then((res:any)=>{
                        this.getList();
                        this.setState({modalVisible:false})
                    })
                }else{
                    this.formRef.current?.resetFields()
                    this.setState({modalVisible:false})
                }
            })

    }
    render() {
        const {
            loading,
            columns,
            data,
            pageIndex,
            pageSize,
            totalCount,
            modalVisible,
            formType
        } = this.state;
        
        return (
            <Translation>{t => {
                return (
                    <>
                        <div>
                            <h5 className="breadcrumbTop py-2">
                                <Breadcrumb>
                                    <Breadcrumb.Item>{t("日志")}</Breadcrumb.Item>
                                </Breadcrumb>
                                <Row style={{padding: "32px 0 19px 0"}}>
                                    <Space>
                                        <img style={{width:30}} src="/images/openapi.png" alt="" />
                                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("API客户端")}</span>
                                    </Space>
                                </Row>
                            </h5>
                            <Row style={{ width: "100%" }}>
                                <div className="borderBox">
                                    <Row className="mb-3">
                                        <Col span={8} offset={1} style={{display: "flex", alignItems: "center"}}>
                                            <label style={{whiteSpace: "nowrap", marginRight: "5px"}}>{t("客户端名称")}: </label>
                                            <Input  placeholder={t("输入客户端名称")} onChange={(e) => {this.setState({search: e.target.value})}}></Input>
                                        </Col>
                                        <Col offset={1}>
                                            <Button
                                                type="primary"
                                                onClick={() => {
                                                    gaEvent("log", "onClick", "onSearch");
                                                    this.onSearch();
                                                }}
                                            >{t("查询")}</Button>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="borderBox" style={{overflow: "hidden"}}>
                                    <Row justify="end">
                                        <Col>
                                            <Button type="primary" onClick={this.addClick}>+{t("添加客户端")}</Button>
                                        </Col>
                                    </Row>
                        
                                    <Table
                                        size="middle"
                                        loading={loading}
                                        dataSource={data}
                                        pagination={false}
                                        rowKey={item => item.id}
                                        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                    >
                                        <Column title={t("序号")} key="index" dataIndex="index" render={(id,  v: any,index) => {
                                            return (<>{index+1}</>)
                                        }}></Column>
                                        <Column title={t("客户端名称")} key="name" dataIndex="name"></Column>
                                        <Column title={t("Client ID")} key="clientId" dataIndex="clientId"></Column>
                                        <Column title={t("密钥")} key="encryptionKey" dataIndex="encryptionKey"></Column>
                                        <Column  title={t("状态")} key="status" dataIndex="status" render={(status,  v: any) => {
                                            return (
                                                <Badge color={ status=== 0 ? "green" : "yellow"} text={ status=== 0 ?  t("正常") : t("失效")} />
                                            )
                                        }}></Column>
                                        <Column  title={t("操作")} key="id" dataIndex="id" render={(id, item: any) => {
                                            return (
                                                <>
                                                    <Button type="text" style={{color: "#007ACC"}} onClick={() => {
                                                        this.editClick(item); 
                                                    }}>{t("编辑")}</Button>
                                                    <Button  type="text" style={{color: "#007ACC"}} onClick={() => {
                                                        this.deleteClick(id); 
                                                    }}>{t("删除")}</Button>
                                                
                                                </>
                                            )
                                        }}></Column>
                                    </Table>
                                    <ConfigProvider locale={i18n.language === "zh" ? zh_CN : en_US}>
                                        <Pagination
                                            style={{textAlign: "right", marginTop: "20px"}}
                                            pageSize={pageSize}
                                            current={pageIndex}
                                            total={totalCount}
                                            showTotal={(total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}`}
                                            onChange={(page, pageSize) => this.getList(page, pageSize)}
                                            onShowSizeChange={(current, size) => this.getList(current, size)}
                                        ></Pagination>
                                    </ConfigProvider>
                                </div>
                            </Row>
                        </div>
                        <Modal
                            width={700}
                            confirmLoading={loading}
                            maskClosable={false}
                            destroyOnClose={false}
                            title={formType=="add"?t("添加"):(formType=="edit"?t("编辑"):t("查看"))}
                            open={modalVisible}
                            onOk={() =>this.formOK()}
                            onCancel={() => {   this.formRef.current?.resetFields();this.setState({modalVisible: false}) }}
                            okText={t("确认")}
                            cancelText={t("取消")}
                            >
                                <Form
                                    ref={this.formRef}
                                    layout="vertical">
                                    <Form.Item label={t("客户端名称")} name="name">
                                        <Input disabled={formType =="show"}></Input>
                                    </Form.Item>
                                    {formType!="add" &&( 
                                    <Form.Item label="ClientId" name="clientId">
                                        <Input disabled></Input>
                                    </Form.Item>)}
                                    {formType!="add" &&( 
                                    <Form.Item label={t("密钥")}  style={{marginBottom:formType=="edit"?4:22}}  name="encryptionKey">
                                        <Input  disabled></Input>
                                    </Form.Item>)}
                                    {formType=="show" &&(
                                        <>
                                        <Button type="primary" onClick={()=>{this.copyEncryptionKey()}}>{t("复制")}</Button>
                                        <span style={{fontSize:12,color:"#DDDDDD",marginLeft:8}}>{t("密钥生成后不在显示，请妥善保存")}</span>
                                        </>
                                    
                                    )}
                                    {formType=="edit" &&(

                                    <Button type="primary" style={{marginBottom:18}} onClick={()=>{this.resetEncryptionKey()}}>{t("重置")}</Button>
                                    )}
                                    {formType=="edit" &&(
                                    <Form.Item label={t("状态")} name="status">
                                        <Select >
                                            <Select.Option value={0} >{t("正常")}</Select.Option>
                                            <Select.Option value={1} >{t("失效")}</Select.Option>
                                        </Select>
                                    </Form.Item>)}
                                </Form>
                                    
                            </Modal>
                    </>
                )
            }}</Translation>
        )
    }
}

export default connect(mapStatetoProps, {})(OpenApi)
